import { ICONS, type IconName } from './icons';

/** A 1-bit pixel icon; one icon pixel is `--ip` (defaults to the UI pixel). Decorative unless `label` is given. */
export function Icon({ name, label, className }: { name: IconName; label?: string; className?: string }) {
  const rows = ICONS[name] as readonly string[];
  const w = rows[0].length;
  const h = rows.length;
  return (
    <svg
      className={`ico${className ? ` ${className}` : ''}`}
      viewBox={`0 0 ${w} ${h}`}
      style={{ width: `calc(${w} * var(--ip, var(--p)))`, height: `calc(${h} * var(--ip, var(--p)))` }}
      shapeRendering="crispEdges"
      fill="currentColor"
      role={label ? 'img' : undefined}
      aria-label={label}
      aria-hidden={label ? undefined : true}
      data-icon={name}
    >
      {rows.flatMap((r, y) => [...r].map((ch, x) => (ch === '#' ? <rect key={`${x}.${y}`} x={x} y={y} width="1" height="1" /> : null)))}
    </svg>
  );
}
